import './publicPath';
import { OverrideStyles } from './blog/override-styles';
import { CartSessionHandler } from './cart/cart-session-handler';
import MediaLoader from './design-system/media-loader';
import Popup from './design-system/popup';
import ButtonLinks from './design-system/button-links';
import { CookieBanner } from './cookie-banner';
import HandlersByClassName from './handlers-by-classname';
import AnchorLinksHandler from './shared/anchor-links-handler';
import Navigation from './navigation';
import CartPopup from './cart-popup';
import VariantDataSelector from './selectors/variant-data';
import CustomerDataSelector from './selectors/customer-data';
import CouponHandler from './coupons/handler';
import FormSubmitHandler from './forms/submit-handler';
import AccessibilityLink from './accessibility-link';
import CurrentVariantStorage from './storage/variant-storage';
import NewCart from './components/cart/index.jsx';
import analytics from './analytics';
import GeoLocation from './geolocation';
import { generateSessionID } from './utils/generate-session-id';

window.variantDataSelector = new VariantDataSelector();
window.customerDataSelector = new CustomerDataSelector();

document.addEventListener('DOMContentLoaded', () => {
  const bodyClassList = document.body.classList;

  analytics.pageLoaded({ classList: bodyClassList });
  window.currentVariantStorage = new CurrentVariantStorage();

  const sessionId = generateSessionID();
  sessionStorage.setItem('session_id', sessionId);

  (new AccessibilityLink()).initialize();
  (new AnchorLinksHandler()).initialize();
  (new ButtonLinks()).initializeEventListeners();
  (new CartPopup()).initializeEventListeners();
  (new CouponHandler()).load();
  (new CookieBanner()).init();
  (new FormSubmitHandler()).initializeEventListeners();
  (new MediaLoader()).initialize();
  (new Navigation()).initializeEventListeners();
  (new NewCart()).initialize();
  (new Popup()).initializeEventListeners();
  (new HandlersByClassName()).initializeHandlers();
  (new OverrideStyles().initialize());

  const geoLocationApi = new GeoLocation();
  geoLocationApi.saveCurrentLocation();

  const CartHandler = new CartSessionHandler(['path', 'visitToken']);
  CartHandler.init();
});
